import * as React from 'react';
import { Form } from 'react-bootstrap'
import { TreeView } from '@progress/kendo-react-treeview'
import '@progress/kendo-react-animation'
import { EditableTree } from '../form-tree-editable/form-tree-editable.styles';

const TreeViewEditable = ({
  id,
  name,
  label,
  placeholder,
  required,
  data,
  item,
  onExpandChange,
  onItemClick,
  expandIcons,
  ...props
}) => {

    return (
      <EditableTree>
        <Form.Group>
          {label && <Form.Label htmlFor={name}>{label}{required && <sup>*</sup>}</Form.Label>}
            <TreeView
              id = {id}
              name = {name}
              data = {data}
              expandIcons = {expandIcons}
              item = {item}
              onExpandChange = {onExpandChange}
              onItemClick = {onItemClick}
            />
        </Form.Group>
      </EditableTree>);
}
export default TreeViewEditable;
